function kelvinToCelsius(temp) {
  if (typeof temp !== 'number') return '';
  return (temp - 273.15).toString().split('.')[0];
}

const obj = { kelvinToCelsius };

export default obj;
